/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Controller for Maintenance Alert.
 */
angular.module('bulbApp.alertsModule')
  .controller('AcceptCookiesAlertController', [
    '$cookies', '$filter', 'BulbAjaxService', 'BulbAuthService', 'ALERT',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    AcceptCookiesAlertController,
  ]);

function AcceptCookiesAlertController($cookies, $filter, BulbAjaxService, BulbAuthService, ALERT) {
  const that = this;
  that.isLoggedIn = BulbAuthService.currentUser.isAuthenticated();

  const cookie = $cookies.get(ALERT.COOKIE_USAGE.COOKIE_NAME);
  if (cookie) {
    that.hasSeenCookieUsageAlert = true;
  } else {
    that.hasSeenCookieUsageAlert = false;
  }

  /**
  * Define close function: Add cookie indicating that this alert has been dismissed.
  */
  this.close = function close() {
    $cookies.put(ALERT.COOKIE_USAGE.COOKIE_NAME, true.toString(), {
      accepted: true,
      expires: new Date(Date.now() + 24 * 60 * 60 * 1000 * ALERT.COOKIE_USAGE.COOKIE_EXPIRES),
      secure: true,
      samesite: 'None',
    });
    // Set secondary value so that alert is NOT visible.
    that.hasSeenCookieUsageAlert = true;
  };

}
